import angular from 'angular';
import SocialCategoryService from './socialCategory.service.js';
import SocialCategorySchema from './socialCategory.schema';

let socialCategoryModule = angular.module('socialCategory', [])

    .service('SocialCategoryService', SocialCategoryService)
    .constant('SocialCategorySchema', SocialCategorySchema)
    .name;

export default socialCategoryModule;
